/**
 * Automy.Core.Enums.Reporting.Operations.PowerBiReportExportStatus
 * JSON `lastStatus` is integer unless a converter is added. Tokens match Power BI REST.
 */
export default Object.freeze({
  NotStarted: 1,
  Running: 2,
  Succeeded: 3,
  Failed: 4,
  Cancelled: 5,
});
